import { useEffect, useRef, useState } from "react";
import { antiTarnishJewellery } from "../../constants/ProductConstants";
import ProductCard from "../product-card/ProductCard";



export default function HomePageProductsSlider({ addToCart, products, title }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const dragStartX = useRef(0);
  const itemsPerSlide = 2;
  const total = products.length;

  // Auto-slide effect
  useEffect(() => {
    if (total <= itemsPerSlide) return undefined;
    const intervalId = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % total);
    }, 4000);
    return () => clearInterval(intervalId);
  }, [total]);

  const goNext = () => {
    setActiveIndex((prev) => (prev + 1) % total);
  };
  const goPrev = () => {
    setActiveIndex((prev) => (prev - 1 + total) % total);
  };

  const handlePointerStart = (clientX) => {
    setIsDragging(true);
    dragStartX.current = clientX;
  };
  const handlePointerEnd = (clientX) => {
    if (!isDragging) return;
    const dragDistance = clientX - dragStartX.current;
    if (dragDistance < -50) goNext();
    if (dragDistance > 50) goPrev();
    setIsDragging(false);
  };

  // Calculate the visible products (window)
  const getVisibleProducts = () => {
    if (total === 0) return [];
    const visible = [];
    for (let i = 0; i < itemsPerSlide; i++) {
      visible.push(products[(activeIndex + i) % total]);
    }
    return visible;
  };

  // For smooth sliding, render all products in a row and shift the row
  const trackWidth = `${(total / itemsPerSlide) * 100}%`;
  const slideWidth = `${100 / total}%`;

  return (
    <section style={styles.section}>
      <h2 style={styles.title}>{title}</h2>
      <div
        style={{ ...styles.carousel, ...(isDragging ? styles.carouselDragging : {}) }}
        onMouseDown={(event) => handlePointerStart(event.clientX)}
        onMouseUp={(event) => handlePointerEnd(event.clientX)}
        onMouseLeave={(event) => handlePointerEnd(event.clientX)}
        onTouchStart={(event) => handlePointerStart(event.touches[0].clientX)}
        onTouchEnd={(event) => handlePointerEnd(event.changedTouches[0].clientX)}
      >
        <div
          style={{
            ...styles.track,
            width: `${total * 100 / itemsPerSlide}%`,
            transform: `translateX(-${(activeIndex * 100) / total}%)`,
            gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))`,
          }}
        >
          {products.map((product) => (
            <div key={product.id} style={styles.cardWrap}>
              <ProductCard product={product} addToCart={addToCart} small />
            </div>
          ))}
        </div>
      </div>
      <div style={styles.dots}>
        {products.map((_, i) => (
          <button
            key={`best-selling-dot-${i}`}
            type="button"
            style={{
              ...styles.dot,
              ...(i === activeIndex ? styles.dotActive : {})
            }}
            onClick={() => setActiveIndex(i)}
            aria-label={`Go to best selling slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

const styles = {
  section: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "0 8px"
  },
  title: {
    margin: 0,
    color: "#DE3163",
    textAlign: "center",
    fontSize: "clamp(1.2rem, 2.8vw, 1.8rem)",
    fontWeight: 600
  },
  subtitle: {
    margin: "8px 0 18px",
    color: "#7a7062",
    fontSize: "0.95rem"
  },
  carousel: {
    overflowX: "hidden",
    overflowY: "visible",
    borderRadius: "14px",
    cursor: "grab",
    padding: "6px 0 16px"
  },
  carouselDragging: {
    cursor: "grabbing"
  },
  track: {
    display: "grid",
    transition: "transform 420ms cubic-bezier(0.77,0,0.18,1)",
    willChange: "transform",
    alignItems: "stretch",
    gap: "14px",
  },
  cardWrap: {
    minWidth: 0,
  },
  dots: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "center",
    gap: "8px"
  },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "999px",
    border: "none",
    background: "#d5c9bb",
    cursor: "pointer",
    transition: "all 220ms ease"
  },
  dotActive: {
    width: "18px",
    background: "#b07b3d"
  }
};
